import * as React from "react";

import { cn } from "../../lib/utils";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] BookEZ_font_color_gray_2 w-full BookEZ_card_bg border BookEZ_input_border_radius BookEZ_card_border_color px-3 py-2 BookEZ_font_body_size ring-offset-background placeholder:BookEZ_font_color_gray_2 focus-visible:outline-none  focus-visible:border-[#2684FF] focus-visible:shadow-[0_0_0_1px_#2684FF] disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
